import { _MainAudioOut } from "../abstractAudio/mainAudioOut.js";
/** @internal */
export class _WebAudioMainOut extends _MainAudioOut {
    /** @internal */
    constructor(engine) {
        super(engine);
        this._volume = 1;
        const audioContext = engine._audioContext;
        this._gainNode = new GainNode(audioContext);
        this._destinationNode = audioContext.destination;
        this._gainNode.connect(this._destinationNode);
    }
    /** @internal */
    get _inNode() {
        return this._gainNode;
    }
    /** @internal */
    get volume() {
        return this._volume;
    }
    /** @internal */
    set volume(value) {
        this._volume = value;
        this.engine._setAudioParam(this._gainNode.gain, value);
    }
    /** @internal */
    dispose() {
        super.dispose();
        this._gainNode.disconnect();
        this._destinationNode.disconnect();
    }
    /** @internal */
    getClassName() {
        return "_WebAudioMainOut";
    }
}
//# sourceMappingURL=webAudioMainOut.js.map